import { imprimirDados } from "OkReport/OkReportGerador";

export default class Report {
    constructor() {
        this.render = this.render.bind(this);
    }

    //
    // Métodos abstratos.
    //

    /**
     * Título do relatório.
     */
    get title() {
        return "";
    }
    get template() {
        return null;
    }

    /**
     * Nome do arquivo.
     */
    get fileName() {
        return this.title;
    }


    get onlyOpen() {

        return false;
    }

    async render() { }

    //
    // Fim dos métodos abstratos.
    //

    async generate(metaAdd) {

        // dados do arquivo aqui
        const result = await this.render();

        function renderSync() {
            return result;
        }

        const model = {
            directCode: renderSync,
            // directGetGraficos: null,
            // descricao: "Relatório de Visita Técnica",
            nome: this.title,
            // tipoModelo: "sSCy71ONYFEwlGVDK4kKUnico",
            publico: true,
            template: this.template,
            onlyOpen:this.onlyOpen
        };

        const meta = {
            nomeArquivo: this.fileName,
            infoVersao: "V." + process.env.REACT_APP_VERSION,
            ...metaAdd
        };

        imprimirDados(model, null, meta);
    }
}
